import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import { TaskIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { ICON_SIZE_MD, ICON_SIZE_SM } from '../../DocumentLinksTab.constants';
import {
  getCardIconTileStyles,
  getGroupIconTileStyles,
  groupCountBadgeStyles,
  groupHeaderStyles,
  groupWrapperStyles,
  linkCardStyles,
  linkNameCellStyles,
  linkNameTypographyStyles,
} from '../../DocumentLinksTab.styles';
import { DocumentLinksTabTestIds } from '../../DocumentLinksTab.testIds';
import { resolveEntityColor } from '../../DocumentLinksTab.utils';

import { TASK_LINK_COLOR_NAME, TASK_LINK_LABEL } from './TaskLinkGroup.constants';

/**
 * Read-only "Task" group of the Links tab: the task a document was submitted to (its TaskId).
 * The task link is set by the task flow itself, so it is not editable here.
 */
const TaskLinkGroup = ({ taskName = null }) => {
  const { bg, fg } = useMemo(() => resolveEntityColor(TASK_LINK_COLOR_NAME), []);

  return (
    <Box data-testid={DocumentLinksTabTestIds.TASK_GROUP} sx={groupWrapperStyles}>
      <Box sx={groupHeaderStyles}>
        <Box sx={getGroupIconTileStyles({ bg, fg })}>
          <TaskIcon size={ICON_SIZE_SM} />
        </Box>
        <Typography variant="medium12">{TASK_LINK_LABEL}</Typography>
        <Box sx={groupCountBadgeStyles}>
          <Typography variant="regular12">1</Typography>
        </Box>
      </Box>

      <Box sx={linkCardStyles}>
        <Box sx={getCardIconTileStyles({ bg, fg })}>
          <TaskIcon size={ICON_SIZE_MD} />
        </Box>

        <Box sx={linkNameCellStyles}>
          <Typography
            data-testid={DocumentLinksTabTestIds.TASK_NAME}
            sx={linkNameTypographyStyles}
            variant="medium14"
          >
            {taskName ?? TASK_LINK_LABEL}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

TaskLinkGroup.propTypes = {
  taskName: PropTypes.string,
};

export default memo(TaskLinkGroup);
